/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIOrganizationSearchResult } from './APIOrganizationSearchResult';
import {
    APIOrganizationSearchResultFromJSON,
    APIOrganizationSearchResultFromJSONTyped,
    APIOrganizationSearchResultToJSON,
} from './APIOrganizationSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIOrganizationSearchResponse
 */
export interface APIOrganizationSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIOrganizationSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIOrganizationSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIOrganizationSearchResult>}
     * @memberof APIOrganizationSearchResponse
     */
    results: Array<APIOrganizationSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIOrganizationSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIOrganizationSearchResponse interface.
 */
export function instanceOfAPIOrganizationSearchResponse(value: object): value is APIOrganizationSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIOrganizationSearchResponseFromJSON(json: any): APIOrganizationSearchResponse {
    return APIOrganizationSearchResponseFromJSONTyped(json, false);
}

export function APIOrganizationSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIOrganizationSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIOrganizationSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIOrganizationSearchResponseToJSON(value?: APIOrganizationSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIOrganizationSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

